<template>
  <BaseDemandCard
    :demand="demand"
    :color="mainColor"
    :demand-color="demandColor"
    :hide-expiration="$_hideExpirationPermanentDemand(demand)"
    :is-overlay-active="isOverlayActive"
    @click="$_goToDemandDetails({ isOverlayActive, demand })"
  >
    <template #header-top-right>
      <PermanentDemandStatus :is-unlocked="demand.isUnlocked()" />
    </template>

    <template #overlay>
      <section class="demand-card-overlay">
        <article v-if="demand.getSelectedCandidateAmount() > 0">
          <p>
            {{ $tc("ETAB.PAGES.RECRUITMENT.TILE.@AMOUNT_CONTACTED", demand.getSelectedCandidateAmount()) }}
            {{ $filters.whitespacedPunctuation($t("ETAB.PAGES.RECRUITMENT.TILE.@DID_YOU_RECRUIT")) }}
          </p>
          <div>
            <DemandCardButton :color="mainColor" variant="filled" @click="$_goToPermanentFeedback(false)">
              {{ $t("ETAB.BUTTONS.@NO") }}
            </DemandCardButton>
            <DemandCardButton :color="mainColor" variant="filled" @click="$_goToPermanentFeedback(true)">
              {{ $t("ETAB.BUTTONS.@YES") }}
            </DemandCardButton>
          </div>
        </article>
        <article v-else>
          <span>
            {{ $tc("ETAB.PAGES.RECRUITMENT.TILE.@NO_CONTACT") }}
          </span>
          <div>
            <DemandCardButton :color="mainColor" variant="filled" @click="$_permanentjobFeedback(demand)">
              {{ $t("ETAB.BUTTONS.@OPEN_FEEDBACK_FORM") }}
            </DemandCardButton>
          </div>
        </article>
      </section>
    </template>

    <template #top>
      <section class="top-card">
        <div class="top-card__application">
          <DemandStatusLabel
            :is-demand-filled="demand.isFilled()"
            :contract-type="demand.getType()"
            :demand-color="demandColor"
            :candidate-applied-count="demand.getAppliedCandidateAmount()"
          />
          <DemandStatusLabel
            v-if="demand.getSelectedCandidateAmount()"
            :is-demand-filled="demand.isFilled()"
            :demand-color="demandColor"
            :candidate-selected-count="demand.getSelectedCandidateAmount()"
            :contract-type="demand.getType()"
          />
        </div>
        <Avatar v-for="(candidate, index) in demand.getCandidates()" :key="index" :picture="candidate.getPicture()" :size="$_avatarSize" />
      </section>
    </template>

    <template #middle>
      <section class="middle-card">
        <span class="contract-date">{{ demand.getSeasonalStartDate() }}</span>
        <DemandAddress :address="demand.getMissionAddress()" />
      </section>
    </template>

    <template #bottom>
      <DemandCardButton v-if="!isOverlayActive" :color="mainColor" variant="filled" @click="$_goToDemandDetails({ demand })">
        {{ $t("ETAB.PAGES.RECRUITMENT.TILE.@OPEN_DEMAND") }}
      </DemandCardButton>
    </template>
  </BaseDemandCard>
</template>

<script>
  import { RecruitmentDashboardModel } from "@core/models";
  import { dashboardDemandMixin } from "@etab/mixins";

  import BaseDemandCard from "./BaseDemandCard.component.vue";
  import DemandCardButton from "./card/Button.component.vue";
  import DemandAddress from "./card/DemandAddress.component.vue";
  import DemandStatusLabel from "./DemandStatusLabel.component.vue";
  import PermanentDemandStatus from "./card/PermanentDemandStatus.component.vue";

  export default {
    components: {
      BaseDemandCard,
      DemandCardButton,
      DemandAddress,
      DemandStatusLabel,
      PermanentDemandStatus,
    },
    mixins: [dashboardDemandMixin],
    props: {
      demand: {
        type: Object,
        default: () => new RecruitmentDashboardModel(),
      },
    },
    computed: {
      mainColor() {
        return this.$_colors.third;
      },
      demandColor() {
        if (this.demand.isFilled()) {
          return this.$_colors.success;
        }
        return this.mainColor;
      },
      hideExpirationOffer() {
        return !this.demand.isUnlocked() || this.demand.isExpired();
      },
      isOverlayActive() {
        return this.demand.isExpired() && this.demand.isUnlocked();
      },
    },
  };
</script>

<style lang="scss" scoped>
  .top-card {
    display: flex;
    align-items: center;
   
    > * {
      margin: 0 2px;
      &:first-child {
        margin-left: 0;
      }
      &:last-child {
        margin-right: 0;
      }
    }
  }

  .middle-card {
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: 100%;
    .contract-date {
      color: $primary;
    }
    .demand-label {
      &__unlocked {
        color: $extra-green;
      }
    }
  }

  .demand-card-overlay {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    font-size: 16px;
    article {
      display: flex;
      flex-direction: column;
      div {
        display: flex;
        margin-top: 8px;
        > button {
          margin: 0 0.5rem;
          &:first-child {
            margin-left: 0;
          }
          &:last-child {
            margin-right: 0;
          }
        }
      }
    }
  }
</style>
